<ui-card>
    <h3>{{ 'applicant-tracker.components.customization-tokens.customizationTokens' | appTranslate }}</h3>
    <p>{{ 'applicant-tracker.components.customization-tokens.copyTheseTokensIntoYourEmail' | appTranslate }}</p>
    <p>[job_posting_title]</p>
    <p>[applicant_first_name]</p>
    <p>[applicant_last_name]</p>
    <p>[applicant_full_name]</p>
    <p>[company_name]</p>
    <p>[my_first_name]</p>
    <p>[my_last_name]</p>
    <p>[my_full_name]</p>
    <p>[my_email]</p>
</ui-card>
